// Application constants
export const DRAWER_WIDTH = 300;
export const DEFAULT_TOKEN_BUFFER_SECONDS = 60;
export const FOCUS_DEBOUNCE_TIME = 3000;

// Mock configuration defaults
export const DEFAULT_MOCK_CONFIG = {
  enabled: true,
  delay: 300,
  failureRate: 0,
  forceLoading: false,
  loadingDuration: 3000,
} as const;

// Storage keys
export const STORAGE_KEYS = {
  MOCKS: 'resi-site-preview-mock-data',
  ACTIVE_MOCKS: 'resi-site-preview-active-mocks',
  MOCK_CONFIG: 'resi-site-preview-mock-config',
  AUTH_STATE: 'resi-site-preview-key',
  REDIRECT_PATH: 'redirectPath',
} as const;

// SWR configuration
export const SWR_CONFIG = {
  ERROR_RETRY_COUNT: 3,
  MAX_RETRY_DELAY: 8,
  DEFAULT_RETRY_INTERVAL: 1000,
  RETRY_STATUS_CODES: [429, 502, 503],
} as const;

export const MOCK_TYPES = {
  CHANNEL: 'channel',
  FEED: 'feed',
  PLAYLIST: 'playlist',
  VIDEO: 'video',
  OTHER: 'other',
} as const;

export const DEFAULT_URLS = [
  {
    dashUrl: 'https://storage.googleapis.com/lao-permanent_content_external/momentum/manifest.mpd',
    hlsUrl: 'https://storage.googleapis.com/lao-permanent_content_external/momentum/masterPlaylist.m3u8',
  },
];

export const INT_EMBED_ID =
  'NmRjZWJlNDYtNDFjMS00OWY5LWEzMTgtODA4MWQxNDM5NGUzOmUwNDkyZDkzLTYwNDgtMTFmMS1iNWZmLThkNTJkMGEyN2FlMw%3D%3D';

export const PROD_EMBED_ID =
  'NmRjZWJlNDYtNDFjMS00OWY5LWEzMTgtODA4MWQxNDM5NGUzOjdkODk2ZGI5LTYwNGUtMTFmMS1iZjQ2LWFiOTQ1NmMxNjQwYQ%3D%3D';

// Channel IDs from Bryan Springham | Resi - Demo Channel (only prod is valid)
export const INT_CHANNEL_ID = '2738f53f-8d11-402e-9794-52902adead33';

export const PROD_CHANNEL_ID = '2738f53f-8d11-402e-9794-52902adead33';
